import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { ReserveMainPageModule } from './pages/reserve-main/reserve-main.module';
import { MyReservesComponent } from './pages/my-reserves/my-reserves.component';
import { IsLoggedInGuard } from './auth/guards/is-logger-in/is-logged-in.guard';
import { MyCommissionsComponent } from './pages/my-commissions/my-commissions.component';
import { MyWalletComponent } from './pages/my-wallet/my-wallet.component';
import { RedirectComponent } from './redirect.component';
import { HasRoleGuard } from './auth/guards/has-roles/has-role.guard';
import { LockerLocationPage } from './components/reserve/locker-location/locker-location.page';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { landingPageGuard } from './pages/landing-page/landing-page.guard';
import { DEFAULT_LANGUAGE } from './services/language/languages';
import { languageGuard } from './services/language/language.guard';
import { LegalPageComponent } from './pages/legal-page/legal-page.component';
import { legalPageResolver } from './pages/legal-page/legal-page.resolver';

const routes: Routes =[
    {
      path: '',
      redirectTo: DEFAULT_LANGUAGE,
      pathMatch: 'full'
    },
    // Public short links predate localized routes and retain their original URL.
    {
      path: 'r/:shortUrl',
      component: RedirectComponent
    },
    {
      path: ':lang',
      canMatch: [languageGuard],
      children: [
    {
      path: '',
      component: LandingPageComponent,
      pathMatch: 'full',
      canActivate: [landingPageGuard]
    },
    ...(['legal-notice', 'privacy-policy', 'terms-service', 'cookie-policy'] as const).map(page => ({
      path: page,
      component: LegalPageComponent,
      data: { page },
      resolve: { legalContent: legalPageResolver },
      runGuardsAndResolvers: 'always' as const,
    })),
    {
      path: 'locker-location', 
      component: LockerLocationPage,
    },
    {
      path: 'locker-locations',
      component: LockerLocationPage,
    },
    { 
      path: 'reserve',          
      loadChildren: () => ReserveMainPageModule
    },
    { 
      path: 'signin',           
      component: SignupPageComponent 
    },
    { 
      path: 'signup',           
      component: SignupPageComponent 
    },
    { 
      path: 'reset',            
      component: SignupPageComponent 
    },
    { 
      path: 'reserves',         
      component: MyReservesComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard] 
    },
    { 
      path: 'my-commissions',   
      component: MyCommissionsComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard, HasRoleGuard], 
      data: {allowedRoles: ['ROLE_COMMISSION_AGENT']} 
    },
    { 
      path: 'my-wallet',        
      component: MyWalletComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard] 
    },
      ]
    },
    { 
      path: '**', 
      redirectTo: DEFAULT_LANGUAGE,
      pathMatch: 'full' 
    }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: false
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
